export default "__VITE_ASSET__BYLakl$9__"